export default __webpack_public_path__ + "static/media/trr-drink-coffeecocktail-coffeetonic.0ff76fc9.png";